if (!customElements.get('supy-cross-sell')) {
  const recsCache = new Map();

  class SupyCrossSell extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-xsell-list]');
      this.error = this.querySelector('[data-xsell-error]');
      this.addEventListener('click', this.onClick.bind(this));
      this.loadComplementary();
    }

    // Shopify's complementary picks win over the manual pairings when the store has any.
    loadComplementary() {
      const productId = this.dataset.productId;
      if (!productId) return;
      const inCart = Array.from(document.querySelectorAll('#CartDrawer .cart-item__name'), (a) => a.pathname).join();
      const key = `${productId}:${inCart}`;
      if (recsCache.has(key)) return this.showRecs(recsCache.get(key));

      const url = `${this.dataset.recsUrl}?section_id=supy-cross-sell-recs&product_id=${productId}&intent=complementary&limit=6`;
      fetch(url)
        .then((response) => (response.ok ? response.text() : ''))
        .then((text) => {
          const recs = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-xsell-recs]');
          const html = recs && recs.querySelector('.supy-xsell__card') ? recs.innerHTML : '';
          recsCache.set(key, html);
          this.showRecs(html);
        })
        .catch(() => {});
    }

    showRecs(html) {
      if (!html || !this.isConnected) return;
      this.list.innerHTML = html;
      this.hidden = false;
    }

    onClick(event) {
      const button = event.target.closest('[data-xsell-add]');
      if (!button || button.disabled) return;
      const card = button.closest('.supy-xsell__card');
      const cartDrawer = this.closest('cart-drawer');
      const sections = cartDrawer.getSectionsToRender().map((section) => section.id);

      button.disabled = true;
      button.classList.add('is-loading');
      this.error.hidden = true;

      fetch(`${this.dataset.addUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(card.querySelector('[data-xsell-variant]').value), quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then((state) => {
          if (state.status) throw new Error(state.description || state.message);
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(state);
        })
        .catch((error) => {
          this.error.textContent = error.message || window.cartStrings?.error || 'something went wrong, please try again';
          this.error.hidden = false;
          button.disabled = false;
          button.classList.remove('is-loading');
        });
    }
  }

  customElements.define('supy-cross-sell', SupyCrossSell);
}
